<template>
  <transition
    name="fade"
    mode="out-in">
    <div class="container mx-auto px-4 max-w-lg pb-12 text-center">
      <h1 class="text-xl font-bold text-center">
        Launching December 6th
      </h1>

      <div class="h-16 border-l border-white inline-block my-6" />

      <countdown
        deadline="2020-12-06"
        class="mb-2" />

      <div class="h-16 border-l border-white inline-block my-6" />

      <p class="font-bold sm:px-20 text-center">
        Fitted quality essentials is the foundation of a stylish wardrobe.
      </p>
    </div>
  </transition>
</template>

<script>
import Countdown from "@/components/Countdown"

export default {
  components: {
    Countdown
  },

  mounted () {
    this.$router.push({ name: "product" })
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
